export const popupConstants = {
    TOGGLE_POPUP: 'TOGGLE_POPUP',
    SET_SUBMIT_SUCCESS_CB: 'SET_SUBMIT_SUCCESS_CB',
    SET_ENTERED_PIN: 'SET_ENTERED_PIN',
    SET_ITEM_CONFIG: 'SET_ITEM_CONFIG',
};
